import { render } from "./Image.vue?vue&type=template&id=02f49b65&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=02f49b65&scoped=true&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f49b65"]])

export default __exports__